<template>
  <div class="button-conponent">
    <div class="setting-button" v-if='type!=="dataButton"'>
      <el-button type="text" class="addButton operation-button" @click="updatePage(-1)"><i v-show="operation.start > 0" class="el-icon-arrow-left"></i>
      </el-button>
      <div class="sort-body">
        <el-button class="create-button" type="default" v-for="btn in getCreateButtons"
                   :key="btn.id" @click.stop="openButtonAttr(btn.id)" :title="btn.name">
          {{btn.name}}
          <span class="el-icon-circle-close delbutton" @click.stop="delButton(btn, 'create')"></span>
        </el-button>
      </div>
      <el-button type="text" class="addButton operation-button" @click="updatePage(1)"><i v-show="buttons.createButtons.length > operation.end" class="el-icon-arrow-right"></i>
      </el-button>
      <el-button type="text" :class="['addButton', buttons.createButtons.length === 20 && 'disabledAddButton']" @click="addButton('create')" title='添加操作按钮'><i class="el-icon-plus"></i>
      </el-button>
    </div>
    <div class="setting-button setting-column-button" v-else>
      <div class="item-button" v-for="(btn,index) in columnButtons" :key="index" >
        <el-button :title="btn.name" @click.stop="openButtonAttr(btn.id)">{{btn.name}}
          <span class="el-icon-circle-close delbutton" @click.stop="delButton(btn, 'update')"></span>
        </el-button>
      </div>
  </div>
   <div class="tip-add" v-if='type==="dataButton"'>
      <span class="el-icon-arrow-up" :class="{'active':active1}" @click="setColumnButtons(-1)"></span>
      <span class="el-icon-arrow-down" :class="{'active':active2}" @click="setColumnButtons(1)"></span>
    </div>
    <el-dialog title="按钮排序"
               :visible.sync="dialog.visable"
               width="386px"
               center
               class="column-button-sort-dialog"
               :close-on-click-modal="false"
               @close="dialog.clickId = ''"
               append-to-body>
      <div class="modal-body">
        <ul class="modal-body-ul">
          <draggable v-model="dialog.sortButtons">
            <transition-group>
              <li class="modal-body-li"
                  v-for="(col,index) in dialog.sortButtons"
                  @click="dialog.clickId = col.id"
                  :key='index'
                  :class="dialog.clickId === col.id ? 'sort-button':'' ">
                <div class="column-name" :class="dialog.clickId === col.id ? 'click-column':'' ">{{col.name}}</div>
                <span class="up" @click="upSortbuttons(index)"></span>
                <span class="down" @click="downSortButtons(index)"></span>
                <span class="delete" @click="delSortButtons(index)"></span>
              </li>
            </transition-group>
          </draggable>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveButtons">保 存</el-button>
        <el-button @click="dialog.visable = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Button from '@/store/report/button.js'
import Draggable from 'vuedraggable'
import Sortable from 'sortablejs'

export default {
  name: 'report-button-component',
  props: ['type'],
  inject: ['reportService'],
  components: {Draggable},
  data () {
    return {
      page: 1,
      dialog: {
        clickId: '',
        sortButtons: [],
        visable: false
      },
      operation: {
        end: 6,
        start: 0
      },
      buttonIndex: {
        createButtonIndex: 1,
        updateButtonIndex: 1
      }
    }
  },
  watch: {
    'reportService.report.mainTableId' () {
      this.buttons = this.$_.cloneDeep(this.reportService.report.buttons)
      // 初始化buttonIndex的值,不能再从1开始,要从现在按钮中含未命名或修改的最大数的按钮开始
      this.getButtonIndex()
      this.type !== 'dataButton' && this.sortCreateButtons()
    }
  },
  computed: {
    active1 () {
      return this.page > 1
    },
    active2 () {
      let active2 = true
      if (Math.ceil((this.buttons.columnButtons.length) / 2) === this.page) {
        active2 = false
      }
      if (this.page === 12) {
        active2 = false
      }
      return active2
    },
    buttons: {
      get () {
        let createButtons = []
        let columnButtons = []
        let buttons = this.$_.cloneDeep(this.reportService.report.buttons)
        // 判断按钮是新建还是非新建按钮，新建的按钮则是表格上面一列的
        buttons.forEach(m => {
          if (['create', 'import', 'export', 'print', 'custom-top', 'filter-item-calculation', 'import-action', 'logic'].some(n => n === m.type)) {
            createButtons.push(m)
          } else {
            columnButtons.push(m)
          }
        })
        return {createButtons, columnButtons}
      },
      set (value) {
        this.reportService.report.buttons = value
      }

    },
    columnButtons () {
      // 需要展示那半个
      let start = 3 * (this.page - 1)
      let end = this.page * 3
      if (this.page > 1) {
        start = start - (this.page - 1)
        end = end - (this.page - 1)
      }
      return this.buttons ? this.buttons.columnButtons.slice(start, end) : []
    },
    getCreateButtons () {
      return this.buttons.createButtons.slice(this.operation.start, this.operation.end)
    }
  },
  methods: {
    setColumnButtons (index) {
      this.page = this.page + index
      if (this.page >= Math.ceil((this.buttons.columnButtons.length) / 2) + 1) {
        this.page = Math.ceil((this.buttons.columnButtons.length) / 2)
        return false
      }
      if (this.page >= 12) {
        this.page = 12
        return false
      }
      if (this.page <= 0) {
        this.page = 1
        return false
      }
    },
    openButtonAttr (buttonId) {
      this.reportService.openPanel(buttonId, 'button-panel')
    },
    delButton (btn, type) {
      this.reportService.delete(btn)
      // 如果当前页是最后一页并且删除完当前页所有按钮，需要滚动到上一页
      this.$nextTick(() => {
        if (type === 'update') {
          this.page = Math.ceil(this.buttons.columnButtons.length / 2)
        } else if (type === 'create') {
          this.operation.start > 0 && this.operation.start--
          this.operation.end > 6 && this.operation.end--
        }
      })
    },
    addButton (type) {
      let button = {}
      if (this.reportService.report.mainTableId === '') {
        this.$message.error('请先设计报表')
        return false
      }
      if (type === 'create') {
        if (this.buttons.createButtons.length >= 20) {
          return false
        }
        // 新建一个新建的按钮，传给vuex
        button = new Button({name: `未命名${this.buttonIndex.createButtonIndex}`, type: 'create', sort: this.buttons.createButtons.length})
        this.buttonIndex.createButtonIndex += 1
      } else {
        // 新建一个修改按钮，传给vuex
        button = new Button({name: `修改${this.buttonIndex.updateButtonIndex}`, type: 'update', sort: this.buttons.columnButtons.length})
        this.buttonIndex.updateButtonIndex += 1
      }
      button.targetType = this.reportService.options.formTargetId ? 'form' : 'flow'
      button.targetId = button.targetType === 'form' ? this.reportService.options.formTargetId : this.reportService.options.processTargetId
      this.reportService.createOrUpdate(button)
      // 添加完当页最后一个之后需要滚动到下一页、
      this.$nextTick(() => {
        if (type === 'create') {
          if (this.buttons.createButtons.length > 6) {
            this.operation.end = this.buttons.createButtons.length
            this.operation.start = this.buttons.createButtons.length - 6
          }
        } else {
          this.page = Math.ceil(this.buttons.columnButtons.length / 2)
        }
      })
    },
    upSortbuttons (index) {
      if (index > 0) {
        let sortColumns = this.dialog.sortButtons
        sortColumns.splice(index - 1, 1, ...sortColumns.splice(index, 1, sortColumns[index - 1]))
      }
    },
    downSortButtons (index) {
      if (index < this.dialog.sortButtons.length - 1) {
        let sortColumns = this.dialog.sortButtons
        sortColumns.splice(index, 1, ...sortColumns.splice(index + 1, 1, sortColumns[index]))
      }
    },
    delSortButtons (index) {
      this.dialog.sortButtons.splice(index, 1)
    },
    saveButtons () {
      // 重新排序之后，需要把sort字段重排
      let buttons = this.dialog.sortButtons
      buttons.forEach((b, i) => { b.sort = i })
      this.reportService.report.buttons = [...buttons, ...this.buttons.createButtons]
      this.dialog.visable = false
    },
    openDialog (buttons) {
      this.dialog.sortButtons = buttons
      this.dialog.visable = true
    },
    updatePage (type) {
      if (type === 1) {
        if (this.buttons.createButtons.length > this.operation.end) {
          this.operation.end += 1
          this.operation.start += 1
        }
      } else {
        if (this.operation.start !== 0) {
          this.operation.end -= 1
          this.operation.start -= 1
        }
      }
    },
    sortCreateButtons () {
      let sortDom = document.querySelectorAll('.button-conponent .setting-button .sort-body')[0]
      let _self = this
      Sortable.create(sortDom, {
        onEnd (e) {
          if (e.newIndex !== e.oldIndex) {
            let buttons = _self.$_.cloneDeep(_self.buttons.createButtons)
            let sortArr = [...buttons].slice(_self.operation.start, _self.operation.end)
            sortArr.splice(e.newIndex, 0, sortArr.splice(e.oldIndex, 1)[0])
            buttons.splice(_self.operation.start, _self.operation.end, ...sortArr)
            // 重新排序之后，需要把sort字段重排
            buttons.forEach((b, i) => { b.sort = i })
            _self.buttons = [...buttons, ..._self.buttons.columnButtons]
          }
        }
      })
    },
    getButtonIndex () {
      let createButtonIndex = 1
      let updateButtonIndex = 1
      if (this.buttons.createButtons.length !== 0) {
        this.buttons.createButtons.forEach(btn => {
          if (btn.name && btn.name.includes('未命名')) {
            createButtonIndex = parseInt(btn.name.match(/未命名(\d+)/)[1]) || 1
          }
        })
      }
      if (this.buttons.columnButtons.length !== 0) {
        this.buttons.columnButtons.forEach(btn => {
          if (btn.name && btn.name.includes('修改')) {
            let btnName = btn.name.match(/修改(\d+)/)
            updateButtonIndex = btnName ? parseInt(btnName[1]) : 1
          }
        })
      }
      if (createButtonIndex > this.buttonIndex.createButtonIndex) {
        this.buttonIndex.createButtonIndex = createButtonIndex + 1
      }
      if (updateButtonIndex > this.buttonIndex.updateButtonIndex) {
        this.buttonIndex.updateButtonIndex = updateButtonIndex + 1
      }
    }
  }
}
</script>

<style lang="scss">
.button-conponent {
  position: relative;

  .setting-button {
    margin: 20px;
    margin: 0;

    .dropdown-button {
      margin-left: 10px;
      margin-right: 10px;

      .el-dropdown__caret-button {
        min-width: 30px;
      }
    }

    .el-button {
      width: 56px;
      height: 24px;
      border: 1px solid #DDDFE6;
      border-radius :4px;
      padding: 0;

      &:hover {

        .delbutton {
          display: block;
        }
      }

      .delbutton {
        position: absolute;
        right: -6px;
        top: -4px;
        line-height: 10px;
        color: #ff2a2a;
        display: none;
      }
    }

    .sort-body {
      display: inline-block;
    }

    .create-button {
      position: relative;
      line-height: 24px;

      &>span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
        display: inline-block;
        font-size: 12px;
      }
    }

    .addButton {
      color: #54abf1;
      border: none;
      width: 20px;
      font-size: 16px;
      vertical-align: top;
      margin: 0;

      .el-icon-plus {
        font-size: 16px;
        &:active{
          color: #388DD2
        }
      }
    }

    .disabledAddButton {
      color: #c9c0c0;
    }

    .operation-button {
      width: 15px;
      margin-left: 5px;
      color: #c9c0c0;
      &:hover, &:active {
        color: #54ABF1;
      }
    }

    &.setting-column-button {
      width: 122px;
      height: 84px;
      padding: 10px 15px 0 15px;
      overflow: hidden;

      .item-button {
        margin-bottom: 6px;
        height: 24px;
        button {
          position: relative;
          width: 66px;
          height: 24px;
          line-height: 24px;
          border: 1px solid #DDDFE6;
          border-radius :4px;
          padding: 0;

          &>span {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 100%;
            display: inline-block;
            font-size: 12px;
          }
        }
      }
    }
  }

  .tip-add {
    position: absolute;
    right: 16px;
    top: 17px;

    span {
      color: #c9c0c0;
      display: block;

      &:nth-child(1) {
        cursor: pointer;
        color: #c9c0c0;
        margin-bottom: 24px;

        &:hover {
          color: #409EFF;
        }
      }

      &.active {
        cursor: pointer;
        color: #409EFF;
      }

    }
  }
}
.column-button-sort-dialog {
  .el-dialog {
     min-width: 386px;
    .el-dialog__body {
      padding: 20px 10px 20px 25px;
      height: 248px;
      .el-button {
        padding: 8px 35px;
      }
      .modal-body-ul {
          li {
            margin: 8px auto;
            height: 28px;
            line-height: 28px;
            position: relative;
            border-radius: 4px;
            cursor: pointer;

            .column-name {
              padding-left: 8px;
              background: #f4f4f4;
              width: 94%;
            }
            .click-column{
              background-color: #ebf6ff;
            }
            span {
              width: 16px;
              height: 16px;
              position: absolute;
              right: 18%;
              top: 50%;
              margin-top: -8px;
              font-size: 24px;
              display: none;
            }
            .up{
              background-image: url("./assets/sort-arrow-upN.png");
            }
            .up:hover{
              background-image: url("assets/sort-arrow-upA.png");
            }
            .down {
              right: 27%;
              background-image: url("./assets/sort-arrow-downN.png");
            }
            .down:hover{
              background-image: url("./assets/sort-arrow-downA.png");
            }
            .delete{
              right: 9%;
              background-image: url("./assets/sort-arrow-delete.png");
            }
            .delete:hover{
              background-image: url("./assets/sort-arrow-deleteA.png");
            }
            &:nth-child(1) {
              .up {
                background-image: url("./assets/sort-arrow-upD.png");
              }
            }
            &:last-of-type {
              .down {
                color: #b7b7b7;
                background-image: url("./assets/sort-arrow-downD.png");
              }
            }
          }
          .sort-button{
            span{
              display: inline-block;
            }
          }
        }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/report/design/report-button-component.vue